import {React,useState} from "react";
import { NavLink } from "react-router-dom";
import { Drawer,List,ListItemButton,ListItemIcon,ListItemText ,IconButton} from "@mui/material";
import MenuIcon  from "@mui/icons-material/Menu";
import { Toolbar,AppBar,Tabs,Tab,Button,useMediaQuery,useTheme } from "@mui/material";


export default function DrawerComp(){
    const[openDrawer, setOpenDrawer] = useState(false);
    return(<div> 
        <Drawer open={openDrawer} onClose={ () => setOpenDrawer(false) }>
            <List>
                <ListItemButton>
                    <ListItemIcon>
                        <ListItemIcon>
                                      <Tabs orientation="vertical" >
                                      <NavLink to="/" ><Tab label="Home" textColor="primary"></Tab></NavLink>
                                      <NavLink to="/Product"><Tab label="Product" textColor="primary"></Tab></NavLink>
                                      <NavLink to="/contact"><Tab label="contact" textColor="primary"></Tab></NavLink>
                                      </Tabs>
                        </ListItemIcon>
                    </ListItemIcon>

                </ListItemButton>
            </List>
        </Drawer>
        <IconButton sx={{color:"#ffffff" , marginLeft: "70vw"}}  onClick={()=> setOpenDrawer(!openDrawer)}>
        <MenuIcon />
        </IconButton>



    </div>)
}